export const STACK_COLORS = [
  'var(--stack-1)',
  'var(--stack-2)',
  'var(--stack-3)',
  'var(--stack-4)',
  'var(--stack-5)',
  'var(--stack-6)'
];

export const STACK_TEXT_COLORS = [
  'var(--text-on-stack-1)',
  'var(--text-on-stack-2)',
  'var(--text-on-stack-3)',
  'var(--text-on-stack-4)',
  'var(--text-on-stack-5)',
  'var(--text-on-stack-6)'
];

export const getColorIndexForLabel = (positions, label, idx = 0) => {
  try {
    if (!Array.isArray(positions)) return 0;
    
    // Handle new position object format
    if (positions.length > 0 && typeof positions[0] === 'object' && positions[0] !== null) {
      const originalIndex = positions.findIndex(p => p?.name === label);
      return originalIndex >= 0 ? originalIndex : (typeof idx === 'number' ? idx : 0);
    }
    
    // Handle old string format
    const originalIndex = positions.indexOf(label);
    return originalIndex >= 0 ? originalIndex : (typeof idx === 'number' ? idx : 0);
  } catch (_) {
    return 0;
  }
};


